import Vue from 'vue'
import { Swiper, Scrollbar, Navigation, Pagination, Autoplay, Thumbs, Mousewheel, EffectFade } from 'swiper'
Swiper.use([Scrollbar, Navigation, Pagination, Autoplay, Thumbs, Mousewheel, EffectFade])

export default el => new Vue({
  name: 'Routine',
  el,
  data() {
    return {
      swiper: null,
      swiperDetails: null,
    }
  },
  methods: {
    initSwiperDetails () {
      const swiperDetailsEl = this.$refs?.swiperDetailsEl
      if (!swiperDetailsEl) return

      this.swiperDetails = new Swiper(swiperDetailsEl, {
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: this.$refs?.paginationEl,
          clickable: true
        },
        navigation: {
          nextEl: this.$refs.nextEl,
          prevEl: this.$refs.prevEl
        }
      })

      this.swiperDetails.on('slideChange', () => {
        this.swiper.slideToLoop(this.swiperDetails.realIndex)
      })
    },
    initSwiperSlider () {
      const swiperEl = this.$refs?.swiperEl
      const swiperThumbsEl = this.$refs?.swiperThumbsEl
      if (!swiperEl && !swiperThumbsEl) return

      const swiperThumbs = new Swiper(swiperThumbsEl, {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 16
      })

      this.swiper = new Swiper(swiperEl, {
        loop: true,
        cssMode: true,
        thumbs: {
          swiper: swiperThumbs
        }
      })

      this.initSwiperDetails()

      swiperThumbs.on('click', (e) => {
        this.swiperDetails.slideToLoop(swiperThumbs.clickedIndex)
      })
    }
  },
  mounted () {
    this.initSwiperSlider()
  }
})
